"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnricherType = exports.InitEnricherType = exports.CustomEnricherType = void 0;
const type_utils_1 = require("@transcend-io/type-utils");
const identifier_1 = require("./identifier");
/**
 * Enrichers that are a bit more freeform, as in they can take in arbitrary inputs
 * and return arbitrary outputs
 */
exports.CustomEnricherType = (0, type_utils_1.makeEnum)({
    /** Notify a server to enrich the variable */
    Server: 'SERVER',
    /** Notify a person to enrich the value */
    Person: 'PERSON',
    /** Check the legal hold list for that enricher type */
    LegalHold: 'LEGAL_HOLD',
    /** Auto approve a specific identifier in a specific situation */
    AutoApprove: 'AUTO_APPROVE',
    /** Test an identifier using a regex */
    RegexMatch: 'REGEX_MATCH',
    /** Perform conditional logic based on region */
    RegionMatcher: 'REGION_MATCH',
    /** Execute an SQL query against a database */
    Database: 'DATABASE',
    /** Execute a look in looker to map identifiers */
    Looker: 'LOOKER',
    /** Adds an enricher dependency */
    WaitPeriod: 'WAIT_PERIOD',
    /** Verify a government ID */
    GovernmentId: 'GOVERNMENT_ID',
});
/**
 * Enrichers that can only be used to initialize the beginning of a DSR
 */
exports.InitEnricherType = (0, type_utils_1.makeEnum)({
    /** Sombra has the capability */
    Sombra: 'SOMBRA',
});
/**
 * The various types of identity enrichers supported by transcend
 */
exports.EnricherType = (0, type_utils_1.makeEnum)({
    ...exports.InitEnricherType,
    ...identifier_1.CommunicationIdentifierType,
    ...exports.CustomEnricherType,
});
//# sourceMappingURL=enricher.js.map